/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import systemAlert from '../../utils/systemAlert';
import { addCounseling, getCounseling, modifyCounseling } from '../../apis/counseling/counseling';
import useForm from '../../hooks/useForm';
import { isEmpty } from '../../utils/lodashExtend';
import { getFormatDateHour } from '../../utils/date';
import { COUNSELING_CATEGORY_TYPES } from '../../constants/COUNSELING';
import Modal, { ModalHeader } from '../Modal';
import Button from '../Button';
import Form from '../Form';
import Comment from '../Comment';
import { shallowEqual, useSelector } from 'react-redux';
import { isNumber } from '../../utils/number';
import { toast } from '../../utils/toast';

const ManagerCounseling = (props) => {
  const { counselingType, counseling, open, setOpen, setCounseling, submit, orgMode } = props;
  const { careCompanies } = useSelector(
    (store) => ({
      careCompanies: store.Data.careCompanies,
    }),
    shallowEqual
  );
  const [mode, setMode] = useState("create");
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([]);

  const [pushEmployees, setPushEmployees] = useState([]);
  const [companies, setCompanies] = useState([]);

  const defaultForm = {
    category: 0,
    title: "",// 제목
    content: "", // 내용
    // isTop: '0', //공지
    // topStartTime: null,
    // topEndTime: null,
    fileIdxes: []
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    submit();
    setOpen(false);
    resetForm(defaultForm);
    setCounseling(null);
  };

  const _submit = (_form) => {

    const form = {
      ..._form,
    };

    if (mode === "create") {
      delete form.idx;
      systemAlert(`"${form.title}" 등록하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '등록',
            onClick: () => {
              addCounseling(counselingType, { ...form })
                .then(() => {
                  toast.success('등록되었습니다.');
                  cancel();
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 수정하시겠습니까?`, {

        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              modifyCounseling(counselingType, counseling.idx, { ...form })
                .then(() => {
                  toast.success('수정되었습니다.');
                  cancel();
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {

    //setMode(isEmpty(counseling) ? 'create' : 'detail');
    setMode(orgMode);

    setCompanies(careCompanies?.filter(f =>
      isNumber(f.managerLevel))?.map(item => ({
        ...item,
        label: `${item.name} (${item.ceoName})`, value: item.companyIdx,
      }))
    );

    // setFormFields(task.fields)
    // debugger
    if (counseling) {
      const form = {
        ...counseling,
        isAnonymous: counseling.isAnonymous ? "1" : "0",
        isTop: counseling.isTop ? "1" : "0",
        fileIdxes: counseling.uploadFiles,
        companyName: counseling?.careCompany?.name,
        ceoName: counseling?.careCompany?.ceoName,
        targetCompanyIdx: counseling.companyIdx,

      };
      setForm(form);
      setOriginForm(form);

      // 알람 리스트 만들기.
      if (!isEmpty(counseling.writerEmployee)) {
        const temp = {
          idx: counseling.writerEmployee.idx,
          isManager: counseling.isManagerWrite ? 1 : 0,
        };

        setPushEmployees([temp]);
      }

    } else {
      setForm({
        ...defaultForm,
      });
      setOriginForm({
        ...defaultForm,
      });
    }

    if (orgMode === 'view' && counseling) {
      getCounseling(counselingType, counseling.idx);
    }

  }, [open, counseling, orgMode, careCompanies]);

  useEffect(() => {
    setFields([
      [
        {
          isHide: mode !== 'view',
          title: mode !== 'view' && "작성자",
          key: "writerEmployee",
          className: 'mt-10',
          type: 'profile'
          // onValue: (data, fields, datas) => {
          //   debugger
          //   return ''
          // }
        },
        {
          isHide: mode !== 'view',
          title: mode !== 'view' && "작성일시", key: "createdTime",
          className: 'text-align-right color-gray-5',
          onValue: (data) => {
            return `작성일 : ${getFormatDateHour(data)}`;
          }
        },
      ],
      {
        isHide: mode !== 'view',
        type: 'line'
      },
      [
        {
          title: "작성회사",
          isHide: mode !== 'create',
          key: "targetCompanyIdx",
          type: "search-select",
          options: { list: companies },
          zIndex: 100,
          isControlShouldRenderValue: true,
          onChange: (data) => {
            setForm({
              targetCompanyIdx: data.value,
              companyName: data.name,
              ceoName: data.ceoName,
            });
          },
        },
        {
          isHide: mode !== 'create',
          title: "카테고리", key: "category", type: "select",
          options: {
            list: COUNSELING_CATEGORY_TYPES,
          },
          className: "zIndex-0",
        },
      ],
      [
        {
          title: "작성회사",
          isHide: mode !== 'modify',
          key: "targetCompanyIdx",
          type: "select",
          options: { list: companies, zIndex: 100 },
          disabled: true,
          className: "zIndex-0",
        },
        {
          isHide: mode !== 'modify',
          title: "카테고리", key: "category", type: "select",
          options: {
            list: COUNSELING_CATEGORY_TYPES,
          },
          className: "zIndex-0",
        },
      ],
      [
        {
          title: "상호명",
          isHide: mode === "view",
          key: "companyName",
          type: "text",
        },
        {
          title: "대표자명",
          isHide: mode === "view",
          key: "ceoName",
          type: "text",
        },
      ],
      [
        {
          isHide: mode === 'view',
          title: "제목", key: "title", type: "input", required: true, readOnly: mode === "modify" ? true : false,
        },
      ],
      [
        {
          className: 'zIndex-0',
          title: mode !== 'view' && "내용",
          key: "content",
          type: "editor",
          required: true,
          height: "300px",
          // readOnly: mode === "modify" ? true : falsezz
        },
      ],
      {
        isHide: mode !== 'view',
        type: 'line'
      },
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
        },
      ],
      {
        isHide: mode !== 'view',
        type: "reaction",
        params: {
          postIdx: "idx",
          postType: "counseling"
        },
        fullWidth: true
      },
    ]);


    setButtons([
      {
        color: 'text',
        label: '닫기',
        onClick: cancel
      },
      {
        isHide: mode !== 'create',
        label: '글쓰기',
        onClick: handleSubmit
      },
      {
        isHide: mode !== 'modify',
        label: '수정하기',
        onClick: handleSubmit
      }
    ]);
  }, [mode, companies, form]);

  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  return (
    <Modal
      isOpen={open}
      // isOpen={true}
      close={cancel}
    // {...mode === 'create' ? { close: cancel } : { toggle: cancel }}
    >
      <div className="client-write">
        <ModalHeader>{counseling ? <>[{COUNSELING_CATEGORY_TYPES.find((item) => Number(item.value) === Number(counseling.category)).label}] {counseling.title}</> : '글쓰기'} </ModalHeader>
        <div className="header-button-wrap">
          {mode === "view" && (
            <Button
              className="print-button print-out"
              color="gray-line"
              label="인쇄"
              onClick={() => window.print()}
            />
          )}
        </div>
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          // submitText={mode === 'create' ? '작성' : '수정'}
          // submit={handleSubmit}
          // cancel={cancel}
          buttons={buttons}
        >
          {mode === 'view' && counseling && (
            <div className="file-upload-list">
              {/* <label className="file-upload-label"></label> */}
              <div className="file-upload-form">
                <Comment
                  postIdx={counseling.idx}
                  postType="counseling"
                  submit={submit}
                  isFirstSubmit={false}
                  param={{ companyIdx: counseling.companyIdx, managerType: counselingType, employees: pushEmployees, title: counseling.title.length <= 7 ? counseling.title : counseling.title.substr(0, 7) + ".." }}
                  isReadCheck={true}
                />
              </div>
            </div>
          )}
        </Form>

      </div>
    </Modal>
  );
};

export default ManagerCounseling;